import type { ImmutableMap } from "@suse-o11y/immutable-map";

import type { LayoutPane } from "./layout-panes/LayoutPane";
import type { PaneName } from "./layout-panes/PaneNames";
import { WestPanes } from "./layout-panes/WestPanes";

export interface LayoutState {
	/**
	 * TODO STAC-18702
	 * It is quite unclear why exactly that `panes` shape exists with almost useless LayoutPane values.
	 * It is absolutely possible to reduce the complexity of the field or even to completely remove it.
	 */
	panes: {
		west: ImmutableMap<PaneName, LayoutPane>;
	};

	/**
	 * TODO STAC-18702
	 * There is no sense to make the panels' location generic.
	 * The `north` panels always is "TopologyQuery", the `west` is "Filter" and the `south` is "Timeline".
	 * Such generic approach gives dozens of impossible states, that we should handle properly
	 * because for TypeScript all of them are possible combinations like.
	 *
	 * activePanes: {
	 *   north: "Filter"
	 *   west: "Filter"
	 *   south: "Filter"
	 * }
	 *
	 * Nonsense 👆, huh?
	 *
	 *
	 * Instead, the fields should be very accurate:
	 * - `LayoutState.isTimelineVisible` instead of `LayoutState.activePanes.south === "Timeline"`
	 * - `LayoutState.isFiltersDropdownOpen` instead of `LayoutState.activePanes.west === "Filter"`
	 *
	 * So the entire `LayoutState.activePanes` can be deleted.
	 */
	activePanes: {
		west?: PaneName;
	};
}

export const initialLayoutState: LayoutState = {
	activePanes: {},
	panes: {
		west: WestPanes,
	},
};
